import { AuthenticatedUserModel } from "@courses-utils/gateway-auth";

import { ElementModel } from "@courses-pm2/api/src/ts/models";
import { Engine, isElement } from "@courses-pm2/api/src/ts/utils";

import { parseElement } from "@courses-pm2/api/src/ts/parser/parseElement";

/**
 * Helper that'll iterate over all direct children of the given node, and parse
 * the supported custom elements.
 */
export async function parseChildElements({ node, portalId, user, engine }: {
    node: Element;
    portalId: string;
    user?: AuthenticatedUserModel;
    engine?: Engine;
}): Promise<ElementModel[]> {
    const children = await Promise.all(
        Array.from(node.childNodes)
            .map((child) => (
                isElement(child)
                    ? parseElement({
                        node: child,
                        portalId,
                        user,
                        engine,
                    })
                    : undefined
            )),
    );

    return <ElementModel[]>children.filter((child) => child !== undefined);
}
